module.exports = __webpack_public_path__ + "img/hall1.0d09dc7f.png";